













































import { Component, Vue } from 'vue-property-decorator'
import { EventHub, Events } from '@/classes/event-hub'
import { Giiker, BatteryInfo } from '@/classes/giiker'

@Component
export default class Device extends Vue {
    private bluetooth = false
    private connected = false
    private loading = false
    private name = ''
    private steps = 0
    private battery = new BatteryInfo(0)

    /* tslint:disable-next-line:max-line-length */
    // private vcs = 'http://roudai.net/visualcube/visualcube.php?fmt=png&size=160&r=y39x-30&bg=t&dist=3&sch=white,E53935,1976D2,yellow,F48FB1,69F0AE'

    // lifecycle
    // --------------------------------------------------
    private mounted() {
        this.bluetooth = Giiker.available()
    }

    private async toggleConnect() {
        this.doWithLoading(async () => {
            if (Giiker.connected()) {
                await Giiker.disconnect()
                this.connected = false
            } else {
                this.name = await Giiker.connect(this.onState, this.onSteps, this.onBattery, this.onDisconnect)
                EventHub.$emit(Events.cubeConnect, this.name)
                this.connected = true
            }
        })
    }

    private async reset() {
        this.doWithLoading(async () => {
            if (this.connected) {
                await Giiker.reset()
                EventHub.$emit(Events.cubeReset)
            }
        })
    }

    private async doWithLoading(func: () => void) {
        this.loading = true
        try {
            await func()
        } catch (e) {
            EventHub.$emit(Events.error, e)
        } finally {
            this.loading = false
        }
    }

    private onState(state: Uint8Array) {
        EventHub.$emit(Events.cubeState, state)
    }

    private onSteps(steps: number) {
        this.steps = steps
    }

    private onBattery(battery: BatteryInfo) {
        this.battery = battery
    }

    private onDisconnect(e: Event) {
        this.connected = false
        EventHub.$emit(Events.cubeDisconnect, this.name)
    }
}
